import React, { useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import MuiAlert from '@material-ui/lab/Alert';
import api from '../api';
import CustomTextField from '../components/customTextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AddBuilding(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [nama, setNama] = React.useState("")
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [errorGedung, setErrorGedung] = React.useState(false);
    const [texterrorGedung, setTextErrorGedung] = React.useState(null);
    const [is_default] = useState([
        { value: 'Tidak', id: 0 },
        { value: 'Ya', id: 1 }
    ])
    const [pickDefault, setPickDefault] = useState(is_default[0])

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const doSubmit = (e) => {
        if (nama === "") {
            setErrorGedung(true)
            setTextErrorGedung("Nama Gedung wajib diisi")
        } else {
            let payload = {
                "name": nama,
                "is_default": pickDefault.id
            }
            api.create().createBuilding(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("Success")
                        props.onClose()
                        props.getData()
                    } else {
                        if (response.data.data) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data)
                            setStatusAlert("Warning")
                        }
                    }
                }
            })
        }
    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Tambah Gedung Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 50px' }}>
                    <div className="column-1">
                        <CustomTextField
                            required={true}
                            label={"Nama Gedung"}
                            error={errorGedung}
                            helperText={texterrorGedung}
                            onChange={(val) => {
                                setNama(val)
                                setErrorGedung(false)
                                setTextErrorGedung(null)
                            }}
                        />
                    </div>
                    <div className="column-2">
                        <Autocomplete
                            disableClearable
                            options={is_default}
                            getOptionLabel={(option) => option.value}
                            onChange={(event, newInputValue) => {
                                setPickDefault(newInputValue)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    label="Default"
                                />
                            }
                            value={pickDefault}
                        />
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => doSubmit(e)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}